<template>
    <div class="userTableBox">
        <div class="headerBox">
        </div>
        <div class="contentBox">
            <el-tabs v-model="activeName" >
                <el-tab-pane label="已认证在线用户列表" name="userBox">
                    <div class="searchBox">
                        <span>执行时间：{{userExecuteTime | timeFormatter}}&nbsp;&nbsp;</span>
                        <el-input v-model="userSearchCondition.select_userName" placeholder="查询关键用户" class="handle-input mr10"></el-input>
                        <el-button type="primary" icon="search" @click="userSearch">搜索</el-button>
                    </div>
                    <el-table :data="userPageinfo.list" border class="tableBox">
                        <el-table-column prop="attributes.userName" label="账号" sortable width="150">
                        </el-table-column>
                        <el-table-column prop="host" label="IP地址" sortable width="150">
                        </el-table-column>
                        <el-table-column prop="startTimestamp" :formatter="startTimeFormatter" label="登录起始时间" width="200" >
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-goods" @click="handleKickout(scope.$index, scope.row)">踢出</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination background :page-size="userSearchCondition.page_size" @current-change="handleUserCurrentChange" layout="prev, pager, next" :total="userPageinfo.total">
                        </el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="临时在线用户列表" name="tempBox">
                    <div class="searchBox">
                        <span>执行时间：{{tempExecuteTime | timeFormatter}}&nbsp;&nbsp;</span>
                        <el-button type="primary" icon="search" @click="tempSearch">刷新</el-button>
                    </div>
                    <el-table :data="tempPageinfo.list" border class="tableBox">
                        <el-table-column prop="attributes.userName" label="账号" sortable width="150">
                        </el-table-column>
                        <el-table-column prop="host" label="IP地址" sortable width="200">
                        </el-table-column>
                        <el-table-column prop="startTimestamp" :formatter="startTimeFormatter" label="登录起始时间">
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination background :page-size="tempSearchCondition.page_size" @current-change="handleTempCurrentChange" layout="prev, pager, next" :total="tempPageinfo.total">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <el-dialog title="提示" :visible.sync="userVisible.kickoutVisible" width="300px" center>
            <div class="del-dialog-cnt">是否确认踢出该在线用户？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="userVisible.kickoutVisible = false">取 消</el-button>
                <el-button type="primary" @click="doKickout">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                userId:'',
                tempExecuteTime:'',
                userExecuteTime:'',
                tempPageinfo: [],
                userPageinfo: [],
                tempSearchCondition:{
                    cur_page: 1,
                    page_size: 8,
                    select_userName: '',
                },
                userSearchCondition:{
                    cur_page: 1,
                    page_size: 8,
                    select_userName: '',
                },
                tableVisible:true,
                userVisible:{
                    kickoutVisible: false,
                },
                activeName:'userBox'
            }
        },
        filters: {
            timeFormatter: function(time) {
                let dateee = new Date(time).toJSON();
                return  new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'');
            }
        },
        created() {
            this.initUserPages();
            this.initTempPages();
        },
        methods: {
            // 分页导航
            handleUserCurrentChange(val) {
                this.userSearchCondition.cur_page = val;
                this.initUserPages();
            },
            handleTempCurrentChange(val) {
                this.tempSearchCondition.cur_page = val;
                this.initTempPages();
            },
            // 获取 easy-mock 的模拟数据
            initUserPages() {
                this.$axios({
                    method:'get',
                    url:  '/api/session/getUserOnLine',
                    withCredentials:true,
                    params: {
                        pageNo: this.userSearchCondition.cur_page,
                        pageSize: this.userSearchCondition.page_size,
                        userAccount: this.userSearchCondition.select_userName,
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code==1){
                        this.$message.success("数据获取成功");
                        this.userPageinfo = response.data.data.userList;
                        this.userExecuteTime = response.data.data.time;
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("获取数据失败")
                    console.log(error)       //请求失败返回的数据
                })
            },
            // 获取 easy-mock 的模拟数据
            initTempPages() {
                this.$axios({
                    method:'get',
                    url:  '/api/session/getTempOnLine',
                    withCredentials:true,
                    params: {
                        pageNo: this.tempSearchCondition.cur_page,
                        pageSize: this.tempSearchCondition.page_size
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code==1){
                        this.$message.success("数据获取成功");
                        this.tempPageinfo = response.data.data.tempList;
                        this.tempExecuteTime = response.data.data.time;
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("获取数据失败")
                    console.log(error)       //请求失败返回的数据
                })
            },
            userSearch() {
                this.initUserPages();
            },
            tempSearch() {
                this.initTempPages();
            },
            handleKickout(index, row) {
                this.userId = row.attributes.userId;
                this.userVisible.kickoutVisible = true;
            },
            // 确定删除
            doKickout(){
                this.$axios({
                    method:'get',
                    url:'/api/session/kickout',
                    withCredentials:true,
                    params: {
                        userId:this.userId
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    this.$message.success(`踢出成功`);
                    this.initUserPages();
                }).catch((error) =>{
                    this.$message.error(`踢出失败`);
                    console.log(error)       //请求失败返回的数据
                }).finally(()=>{
                    this.userVisible.kickoutVisible = false;
                    this.userId = '';
                })
            },
            startTimeFormatter(row, column){
                return this.$tools.formatUnixtimestamp(row.startTimestamp);
            },
        }
    }

</script>

<style scoped>
    .userTableBox{
        /*padding:20px;*/
        width:100%;
    }
    .contentBox{
        padding:20px;
        background-color: white;
    }
    .searchBox{
        padding-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .tableBox{
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
    
    .el-transfer-panel__list.is-filterable{
        width:500px;
    }
</style>
